export enum RecurrenceType {
  ONCE = 'ONCE',
  DAILY = 'DAILY',
  CUSTOM = 'CUSTOM',
}
